interface DisplayOnlyPageFrameProps {
  displayMode?: 'normal' | 'source_only';
  displayNotice?: string | null;
  children: React.ReactNode;
}


export default function DisplayOnlyPageFrame({
  displayMode,
  displayNotice,
  children,
}: DisplayOnlyPageFrameProps) {
  const showNotice = displayMode === 'source_only' && Boolean(displayNotice);

  return (
    <div className="block">
      {showNotice && (
        <div
          className="mb-2 rounded border border-amber-300 bg-amber-100 px-3 py-2 text-sm text-amber-950"
          role="note"
        >
          {displayNotice}
        </div>
      )}
      {children}
    </div>
  );
}
